// eslint-disable-next-line
import worker from 'workerize-loader!./worker';

export default worker;
